$(function () {
  if (!customElements.get('product-sticky-form-price')) {
    customElements.define(
      'product-sticky-form-price',
      class ProductStickyFormPrice extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.init();
        }

        disconnectedCallback() {}

        init() {}
      }
    );
  }
});
